import {
  Alert as ChakraAlert,
  AlertIcon,
  AlertDescription,
  CircularProgress,
  CloseButton,
  Flex,
  PropsOf,
  useDisclosure,
} from '@chakra-ui/react';
import type { AlertProps } from '@chakra-ui/react';
import React from 'react';

type AlertComponentProps = {
  isClosable?: boolean;
  children: React.ReactElement;
  margin?: string;
} & PropsOf<typeof ChakraAlert>;
export const Alert = ({
  isClosable = false,
  children,
  margin,
  ...alertProps
}: AlertComponentProps) => {
  const { isOpen: isVisible, onClose } = useDisclosure({
    defaultIsOpen: true,
  });
  return isVisible ? (
    <ChakraAlert
      {...{ ...alertProps, variant: alertProps.variant || 'subtle' }}
      w="100%"
      m={margin ?? '16px 0'}
      borderRadius="lg"
    >
      <Flex w="100%">
        <AlertIcon />
        {children}
      </Flex>
      {isClosable && <CloseButton alignSelf="flex-end" onClick={onClose} />}
    </ChakraAlert>
  ) : null;
};

export const ProgressAlert = ({ children, ...otherProps }: AlertProps) => {
  return (
    <ChakraAlert {...otherProps} status="info">
      <CircularProgress size="18px" isIndeterminate mr="16px" />
      <AlertDescription>{children}</AlertDescription>
    </ChakraAlert>
  );
};
